import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import { useScrollManager } from '../../hooks/useScrollManager';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { HandDrawnButton } from '../../components/shared/HandDrawnButton/HandDrawnButton';
import { useTranslation } from '../../i18n';
import './GettingHereMendoza.css';

const GettingHereMendoza: React.FC = () => {
  const { scrollState } = useScrollManager();
  const { setHoveredDestination } = useOverlayManager();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
    initializeAllFeatures();
    // Clear any lingering hover state to ensure correct footer variant
    setHoveredDestination(null);
  }, []);

  // Figma asset URLs
  const fullImage = '/assets/images/localhost/b511fc05b56f6f56ab808fe346dacf0108ddd079.png';
  const mapImage = '/assets/images/localhost/e81ab367ef65525aad1480d1faddeb5f7050ad91.png';
  const mapNavigation = '/assets/images/localhost/7480369bf8335012f137f5425989842c4b1fc8cf.png';
  const mendozaLogoSmall = '/assets/images/localhost/cb0c7d03b8fd9ce19313644f58103ee696e9624c.svg';
  const mendozaLogoSmall2 = '/assets/images/localhost/0501557fb03c945e93b7f590ca32f7a6f081cb88.svg';
  const markerArrow = '/assets/images/localhost/a33ba1312186de6cc92a2a3b035bfed60a30305c.svg';

  return (
    <div className="getting-here-mendoza">
      {/* Navigation - Mendoza variant (light) */}
      <UnifiedNavigation variant="light" destination="mendoza" />

      {/* Header Text Block */}
      <section className="getting-header-section" data-scroll-section>
        <div className="getting-header-content">
          <h1>How to get here</h1>
          <p>
            The lodge is located 20 miles south of Mendoza city in Agrelo, Lujan de Cuyo, a spot with breathtaking landscapes and home to some of the most prestigious wineries in Argentina.
          </p>
        </div>
      </section>

      {/* Full Width Image */}
      <section className="getting-fullwidth-image" data-scroll-section>
        <div 
          className="fullwidth-image-container"
          style={{ backgroundImage: `url('${fullImage}')` }}
        />
      </section>

      {/* Map Section */}
      <section className="getting-map-section" data-scroll-section>
        <div className="map-section-container">
          {/* Map Image */}
          <div className="map-container">
            <div 
              className="map-image"
              style={{ backgroundImage: `url('${mapImage}')` }}
            >
              {/* Map Navigation Controls */}
              <div 
                className="map-navigation"
                style={{ backgroundImage: `url('${mapNavigation}')` }}
              />
              
              {/* Mendoza Location Marker */}
              <div className="map-marker">
                <div className="marker-tag">
                  <img src={mendozaLogoSmall} alt="Mendoza" className="marker-logo" />
                  <img src={mendozaLogoSmall2} alt="logo" className="marker-logo-overlay" />
                </div>
                <img src={markerArrow} alt="arrow" className="marker-arrow" />
              </div>
            </div>
          </div>

          {/* Text Block */}
          <div className="map-text-block">
            <h2>Getting to Awasi Mendoza</h2>
            
            <div className="map-text-content">
              <p>
                The lodge is only 40 minutes' drive from Mendoza International Airport and 25 minutes' drive from Mendoza city. Drive South of Mendoza city on Route 40 and take route 7 towards Chile. 4 km straight west and then turn left on Calle Costa Flores. The lodge is 2 km from route 7 (dust road).
              </p>

              <div className="contact-buttons">
                <HandDrawnButton
                  text={t('common:buttons.contactUs')}
                  onClick={() => console.log('Contact us')}
                  variant="mendoza"
                  color="awasi"
                  animation="stroke-to-fill"
                  size="normal"
                  className="getting-here-contact-button"
                />
                <HandDrawnButton
                  text={t('common:buttons.learnMore')}
                  onClick={() => console.log('Learn more')}
                  variant="mendoza"
                  color="awasi"
                  animation="stroke-to-stroke"
                  size="normal"
                  className="getting-here-learn-button"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Transfer Information Block */}
      <section className="getting-transfer-section" data-scroll-section>
        <div className="transfer-content">
          <h2>
            Please inquire for transfer options from the airport.
          </h2>
          <HandDrawnButton
            text={t('common:buttons.contactUs')}
            onClick={() => console.log('Contact us')}
            variant="mendoza"
            color="off-white"
            animation="stroke-to-fill"
            size="wide"
            className="getting-here-main-contact-button"
          />
        </div>
      </section>

      {/* Instagram Gallery */}
      <div className="instagram-section-wrapper">
        <InstagramSection />
      </div>

      {/* Footer - Mendoza variant */}
      <Footer variant="mendoza" />
    </div>
  );
};

export default GettingHereMendoza;